import React from "react"
import { Modal } from "react-bootstrap"

const PlayVideo = ({ url, isOpen, onClose }) => {
  if (!url) return null

  const generateMatterportURL = (url) => {
    const isMatterport = url.includes("vt.ehouse.co.uk") || url.includes("matterport.com");
    const urlId = url.match(/\/([^/?]+)$/)?.[1] || url.split('/?m=').pop() ;
    return isMatterport && urlId ? `https://my.matterport.com/show/?m=${urlId}&play=1` : ``;
  };

  const matterportUrl = generateMatterportURL(url);

  return (
    <Modal
      fullscreen
      show={isOpen}
      onHide={() => onClose(false)}
      dialogClassName="property-details-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="p-0">
        <iframe src={matterportUrl} title={`Matterport 3D Tour`}></iframe>
      </Modal.Body>
    </Modal>
  )
}

export default PlayVideo
